import {Timeline,} from "antd";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon} from "../../../asset";
import style from "./SellerDetail.module.css";
import axios from "axios";
import {ROUTES} from "../../../constant/routeConstant";
import {useLocation, useNavigate} from "react-router-dom";
import {doGet} from "./SellerService";
import Breadcrumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import {useSelector} from "react-redux";
import {GROLOG_BASE_URL} from "../../../constant/apiConstant";
import moment from "moment";

const SellerDetail = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);

  useEffect(() => {
    fetchData();
    getManagementHistoryList()
  }, []);

  const doGetBaseUrl = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = {"Authorization": token};
    const request = {url, method, headers, params};
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq role, primary_key eq ${location.state.id}`);

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data?.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element)
    }

    setManagementHistoryList(reorderedData)
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];
    let dateFormat = new Date(timestamp);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  };

  const convertToTime = (timestamp) => {
    return (moment(timestamp).utc().format('HH:mm'))
  };

  const {token, client_id, grolog_account_id, userId} = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const fetchData = async () => {
    let res = await doGet(`/role/${location.state.id}?${param}`, token);
    setDetail(res?.data?.payload?.data);
    console.log("DETAIL ", res?.data?.payload?.data);
  };

  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcrumbs
          jmlLevel={3}
          menuLevel1={`Master`}
          menuLevel2={`Seller`}
          menuLevel3={"Detail " + detail.role_id}
        />

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => navigate(ROUTES.SELLER.LIST)}>
            <img
              src={BackIcon}
              alt=""
            />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail.role_id}
            </h1>
          </div>
          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer'
               onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}&nbsp;
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")}&nbsp;
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong></p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            paddingLeft: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className="flex flex-col gap-[0px]">
            {/* Seller Info */}
            <div>
              <h3 className="font-roboto text-[20px] font-bold mt-6">
                {t("Seller Information")}
              </h3>
              <div className="flex mt-[16px]">
                {/* line one */}
                <div className="gap-[40px] mb-[24px]">
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Seller ID")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Phone 2")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Owner Name")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                </div>
                {/* line two */}
                <div className="gap-[40px] mb-[24px]">
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Seller Name")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Email")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Owner Phone")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                </div>
                {/* line three */}
                <div className="gap-[40px] mb-[24px]">
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Phone")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Tax Number")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Seller Address Info */}
            <div>
              <h3 className="font-roboto text-[20px] font-bold">
                {t("Seller Address Info")}
              </h3>
              <div className="flex mt-[16px]">
                {/* line one */}
                <div className="gap-[40px] mb-[16px]">
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Country")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Sub District")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Neighbourhood")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                </div>
                {/* line two */}
                <div className="gap-[40px] mb-[16px]">
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Province")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Urban Village")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Halmet")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                </div>
                {/* line three */}
                <div className="gap-[40px] mb-[16px]">
                  <div className="w-[350px] mb-[24px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("District")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Address")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.role_id}
                    </h4>
                  </div>
                  <div className="w-[350px] mb-[16px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Postal Code")}
                    </label>
                    <h4 className="font-roboto text-[20px] text-[#424242]">
                      {detail?.description}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <aside
            className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
            <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
              <img src={CloseIcon} alt=""/>
            </button>

            <h3
              className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
            <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}
              <strong>{convertTimestamp(detail?.created_at)}</strong></p>


            <div className={style.timelineContainer}>
              <Timeline>
                {
                  managementHistoryList.map((item, index) => {
                    if (index === 0) {
                      return <Timeline.items dot={<img src={ActiveDotIcon}/>}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4
                            className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p
                            className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.items>
                    } else {
                      return (
                        <Timeline.Item dot={<img src={InactiveDotIcon}/>}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p
                              className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                      )
                    }
                  })
                }
              </Timeline>
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};
export default SellerDetail;
